module.exports = __webpack_public_path__ + "static/img/logo-cn.9a26ee5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/logo-cn.png?v=1
// module id = yUq6
// module chunks = 1